module.exports = __webpack_public_path__ + "img/img_element_three.9d39f835.svg";